import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Label, Input, FormFeedback } from 'reactstrap';
import moment from 'moment';

import api from "../../../api";
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker"
import CurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import { formatCurrency } from './../../functions/dateFunctions.js'

const parseMontoFloat = (x) => (parseFloat(((x.toString()).replace(/[.]/g, '')).replace(',', '.')));

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fecha: moment(),
            cuentaCorriente: null,
            categoria: null,
            unidadVinculacionTecnologica: null,
            ingreso: '0',
            egreso: '0',
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            fecha: moment(data.fecha),
            cuentaCorriente: data.cuenta_corriente_id,
            categoria: data.categoria_id,
            unidadVinculacionTecnologica: data.unidad_vinculacion_tecnologica_id,
            ingreso: formatCurrency(data.ingreso_monto),
            egreso: formatCurrency(data.egreso_monto),
        });
    }

    onChangeCuentaCorriente = (cuentaCorriente) => {
        this.setState({ 
            cuentaCorriente: cuentaCorriente ? cuentaCorriente.pk : null,
        });
    }

    onChangeCategoria = (categoria) => {
        this.setState({ 
            categoria: categoria ? categoria.pk : null,
        });
    }

    onChangeUnidadVinculacionTecnologica = (unidadVinculacionTecnologica) => {
        this.setState({
            unidadVinculacionTecnologica: unidadVinculacionTecnologica ? unidadVinculacionTecnologica.pk : null,
        });
    }

    onIngresoChange = (ingreso) => {
        this.setState({ ingreso });
    }

    onEgresoChange = (egreso) => {
        this.setState({ egreso });
    }

    onFechaChange = (fecha) => {
        this.setState({ fecha: moment(fecha) });
    }

    render() {
        const {
            fecha,
            cuentaCorriente,
            categoria,
            unidadVinculacionTecnologica,
            ingreso,
            egreso,
        } = this.state

        return (
            <ParadigmaModal
                getUrl={api.saldos.movimientos.edit}
                postUrl={api.saldos.movimientos.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Movimiento ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Movimiento"}
                buttonTitle={"Editar Movimiento"}
                buttonIcon={"fa fa-pencil fa-lg"}

                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-lg"}
                onGotData={(data) => this.setSelects(data)}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del movimiento</p>
                        <div className="ui-section-grid">
                            <div className="ui-field">
                                <Label>Fecha</Label>
                                <ParadigmaDatePicker fieldName={"fecha"} datetime={false} monthpicker={false} value={fecha} onChange={this.onFechaChange} />
                            </div>
                            <div className="ui-field">
                                <Label>Cuenta Corriente</Label>
                                <ParadigmaAsyncSeeker fieldName={"cuenta_corriente"} nombreField={"subgrupo_nombre"} url={api.saldos.cuentasCorrientes.selectRestringido} value={cuentaCorriente} onChange={this.onChangeCuentaCorriente} />
                            </div>
                            <div className="ui-field">
                                <Label>Categoria</Label>
                                <ParadigmaAsyncSeeker fieldName={"categoria"} url={api.saldos.categorias.select} value={categoria} onChange={this.onChangeCategoria} />
                            </div>
                            <div className="ui-field">
                                <Label>UVT</Label>
                                <ParadigmaAsyncSeeker fieldName={"unidad_vinculacion_tecnologica"} url={api.proyectos.config.presupuesto.uvt.select} value={unidadVinculacionTecnologica} onChange={this.onChangeUnidadVinculacionTecnologica} />
                            </div>
                            <div className="ui-field ui-section-span-2">
                                <Label>Factura</Label>
                                <Input type="text" name="factura"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field ui-section-span-2">
                                <Label>Descripción</Label>
                                <Input type="textarea" rows={4} name="descripcion"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                    <section className="ui-section-block">
                        <p className="ui-section-label">Importes</p>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Ingreso ($)</Label>
                                <Fragment>
                                    <CurrencyInput placeholder='0' className='monto' selectOnFocus={true} maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }} value={ingreso} onChange={this.onIngresoChange} />
                                    <Input type="hidden" name={"ingreso_monto"} value={parseMontoFloat(ingreso)} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </Fragment>
                            </div>
                            <div className="ui-field">
                                <Label>Egreso ($)</Label>
                                <Fragment>
                                    <CurrencyInput placeholder='0' className='monto' selectOnFocus={true} maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }} value={egreso} onChange={this.onEgresoChange} />
                                    <Input type="hidden" name={"egreso_monto"} value={parseMontoFloat(egreso)} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </Fragment>
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Observación</Label>
                                <Input type="textarea" rows={4} name="observacion"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Saldos/Movimientos/Edit.js